function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardContent } from '@ui/primitives';
import { AlertCircle } from 'lucide-react';
export function DangerZoneContainer(param) {
    let { className, items, dataE2E } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "rounded-lg border-2 border-destructive/20 bg-destructive/5 p-6 ".concat(className !== null && className !== void 0 ? className : ''),
        "data-e2e": dataE2E,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-4 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(AlertCircle, {
                        className: "h-5 w-5 text-destructive"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-lg font-semibold text-destructive",
                        children: "Danger zone"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "space-y-4",
                children: items.map((item)=>/*#__PURE__*/ _jsx(DangerZoneItem, _object_spread({}, item), item.label))
            })
        ]
    });
}
function DangerZoneItem(param) {
    let { label, content, buttonProps, dataE2E } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-start justify-between gap-4 rounded-md border border-border bg-background p-4",
        "data-e2e": dataE2E,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-1 space-y-1",
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        className: "font-medium",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-sm text-muted-foreground",
                        children: content
                    })
                ]
            }),
            buttonProps && /*#__PURE__*/ _jsx(Button, {
                variant: "destructive",
                onClick: buttonProps.onClick,
                disabled: buttonProps.disabled,
                className: "shrink-0",
                "data-e2e": buttonProps.dataE2E,
                children: buttonProps.title
            })
        ]
    });
}
export function DangerZone(param) {
    let { title, description, buttonText, onConfirm, disabled } = param;
    return /*#__PURE__*/ _jsx(Card, {
        className: "border-destructive/20 bg-destructive/5",
        children: /*#__PURE__*/ _jsxs(CardContent, {
            className: "p-6",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "mb-4 flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(AlertCircle, {
                            className: "h-5 w-5 text-destructive"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "text-lg font-semibold text-destructive",
                            children: "Danger zone"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-start justify-between gap-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex-1 space-y-1",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "font-medium",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: description
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "destructive",
                            onClick: onConfirm,
                            disabled: disabled,
                            className: "shrink-0",
                            children: buttonText
                        })
                    ]
                })
            ]
        })
    });
}
